"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.scrollingContainerStyles = void 0;
const scrollingContainerStyles = exports.scrollingContainerStyles = {
    height: '100%',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    width: '100%'
};
